import React from "react"
import "./index.scss"
import { Link } from "gatsby"

export default function InnerUpdateProjectCard({ component }) {
  const { headline, description, cardLink, tag } = component
  return (
    <>
      <a href={cardLink[0].linkUrl} target="_blank" rel="noreferrer">
        <div className="inner-card">
          <span className="tag">{tag}</span>
          <h5>{headline}</h5>
          <div
            className="inner-card--text"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <a href={cardLink[0].linkUrl} target="_blank" rel="noreferrer">
            {cardLink[0].label}
          </a>
        </div>
      </a>
    </>
  )
}
